"use client";

import React, { useState, useEffect } from 'react';

export default function PartnersSection() {
  const [showModal, setShowModal] = useState(false);

  // Impede a rolagem do body quando o modal está aberto
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
    return () => {
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
    };
  }, [showModal]);

  return (
    <>
      {/* Parceiros Marquee */}
      <div
        className="cgt-partners-wrapper cursor-pointer group"
        onClick={() => setShowModal(true)}
        title="Clique para ver todos os parceiros"
      >
        <h3 className="cgt-partners-title cgt-title-font group-hover:text-[#006437] transition-colors duration-300">Nossos Parceiros</h3>
        <div className="cgt-partners-track group-hover:opacity-80 transition-opacity duration-300">
          {/* Renderiza 2 vezes para o efeito infinito (50%) */}
          {[...Array(2)].map((_, loopIndex) => (
            <React.Fragment key={loopIndex}>
              {[...Array(23)].map((_, i) => (
                <div className="cgt-partner-item" key={`${loopIndex}-${i}`}>
                  <img
                    src={`https://casadoguerreirotricolor.com.br/parceiros/${i + 1}.png`}
                    alt={`Parceiro ${i + 1}`}
                    loading="eager"
                  />
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Modal de Parceiros */}
      {showModal && (
        <div
          className="fixed inset-0 z-[9999] bg-black/80 flex items-center justify-center p-4 backdrop-blur-sm transition-all"
          onClick={() => setShowModal(false)}
        >
          <div
            className="w-full max-w-5xl max-h-[90vh] flex flex-col shadow-2xl rounded-xl overflow-hidden relative animate-in fade-in zoom-in duration-200"
            onClick={(e) => e.stopPropagation()}
            style={{ transform: 'translateZ(0)' }}
          >
            {/* Header Modal */}
            <div className="bg-[#6b1122] text-white p-4 sm:p-5 flex justify-between items-center shrink-0 shadow-md z-10 relative">
              <h2 className="font-['Bebas_Neue'] text-3xl sm:text-4xl tracking-wider m-0 leading-none" style={{ fontFamily: "'Bebas Neue', 'Impact', sans-serif" }}>
                NOSSOS PARCEIROS
              </h2>
              <button
                onClick={() => setShowModal(false)}
                className="text-white hover:text-white p-1.5 bg-black/20 hover:bg-black/40 rounded-full transition-colors focus:outline-none"
              >
                <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Grid Modal */}
            <div className="p-4 sm:p-6 overflow-y-auto flex-1 bg-[#f4f4f4]">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
                {[...Array(23)].map((_, i) => (
                  <div key={i} className="bg-white border border-gray-200 rounded-lg p-4 flex items-center justify-center shadow-sm hover:shadow-lg transition-all h-28 sm:h-36 hover:border-[#006437] hover:-translate-y-1">
                    <img
                      src={`https://casadoguerreirotricolor.com.br/parceiros/${i + 1}.png`}
                      alt={`Parceiro ${i + 1}`}
                      className="max-w-full max-h-full object-contain"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
